import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    constructor() {}

    getAuthApiUrl(): string {
        return environment.authApiUrl;
    }

    getBffApiUrl(): string {
        return environment.bffApiUrl;
    }
}
